<div class="row">
	<div class="col-md-6  text-left">
		<button class="btn btn-accent" (click)="addNote()">Add Note</button>
	</div>
	<div class="col-md-6 text-right">
		<button class="btn btn-primary" (click)="onSubmit()">Save</button>
	</div>
</div>
<ul @grow class="list-group list-group-flush p-0 m-0">
	<li class="list-group-item note-row-inline" *ngFor="let note of customer.notes ">
		<div class="inline-wrap">
			<div class="inline-type">
				<label class="note-type-label">Note Type</label>
				<select aria-label="Note Type" class="select" required (change)="updateTopic({ value: $event.target.value }, note)">
					<option *ngFor="let type of notetypes" [value]="type" [selected]="type === note.note_code">{{type}}</option>
				</select>
			</div>
			<div class="inline-input">
				<div class="input-container">
					<button 
						*ngIf="speechRecognitionService?.getIsSupported()"
						type="button"
						class="icon-button input-button-left"
						[title]="(isVoiceRecordingNote && currentVoiceNoteId === note.noteid) ? 'Stop Recording' : 'Record to this note'"
						(click)="$event.preventDefault();$event.stopPropagation();toggleVoiceEditNote(note);"
						[class.voice-active]="isVoiceRecordingNote && currentVoiceNoteId === note.noteid">
						<i class="material-icons" [class.text-warning]="isVoiceRecordingNote && currentVoiceNoteId === note.noteid" [class.voice-pulse]="isVoiceRecordingNote && currentVoiceNoteId === note.noteid">{{ (isVoiceRecordingNote && currentVoiceNoteId === note.noteid) ? 'mic' : 'mic_none' }}</i>
					</button>
					<div class="input-wrap">
						<input class="input" #noteInput required placeholder="Note" name="note[{{note.noteid}}]" [attr.data-noteid]="note.noteid" [value]="note.note" (input)="updateNote($event, note)" >
						<span class="badge badge-recording" *ngIf="isVoiceRecordingNote && currentVoiceNoteId === note.noteid">Recording…</span>
					</div>
					<button type="button" class="icon-button input-button-right remove-button" (click)="removeNote(note.noteid)" *ngIf="note.noteid > 0" title="Remove note">
						<i class="material-icons remove-icon">close</i>
					</button>
				</div>
			</div>
		</div>
	</li>
</ul>
